import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { ConfigService } from '../../config/config.service';
import { map, startWith, switchMap } from 'rxjs/operators';
import { NavigationService } from '../../services/navigation.service';
import { PopoverService } from '../../components/popover/popover.service';
import { MegaMenuComponent } from '../../components/mega-menu/mega-menu.component';
import { Observable, of } from 'rxjs';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { DetailsMenuComponent } from 'src/@vex/components/details-menu/details-menu.component';
import { OperationMenuComponent } from 'src/@vex/components/operation-menu/operation-menu.component';
import { ReportsMenuComponent } from 'src/@vex/components/reports-menu/reports-menu.component';
import { ICandidate, IExam } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { el, th, tr } from 'date-fns/locale';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ComplaintService } from 'src/app/services/complaint-services.service';
import { UserMenuComponent } from 'src/@vex/components/user-menu/user-menu.component';
import { SetupMenuComponent } from 'src/@vex/components/setup-menu/setup-menu.component';
import { QuestionBankService } from 'src/app/questions-bank/question-bank.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {

  @Input() mobileQuery: boolean;
  tem = true;
  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;
  errorEventHandler: any;
  navigationItems = this.navigationService.items;
  selectedExam: IExam = null;
  isHorizontalLayout$: Observable<boolean> = this.configService.config$.pipe(map(config => config.layout === 'horizontal'));
  isVerticalLayout$: Observable<boolean> = this.configService.config$.pipe(map(config => config.layout === 'vertical'));
  isNavbarInToolbar$: Observable<boolean> = this.configService.config$.pipe(map(config => config.navbar.position === 'in-toolbar'));
  isNavbarBelowToolbar$: Observable<boolean> = this.configService.config$.pipe(map(config => config.navbar.position === 'below-toolbar'));
  userVisible$: Observable<boolean> = this.configService.config$.pipe(map(config => config.toolbar.user.visible));

  megaMenuOpen$: Observable<boolean> = of(false);
  enableOps = false;
  enableDetails = true;
  enableOperations = true;
  enableSetUp: boolean;
  enableReports = true;
  canBack = true;
  currentRoute = "";
  exam: IExam = null;
  candidate: ICandidate = null;
  userMenuOpen$: Observable<boolean> = of(false);
  title = '';
  constructor(private layoutService: LayoutService,
    private configService: ConfigService,
    private navigationService: NavigationService,
    private popoverService: PopoverService, private route: Router,
    private examService: ExamService, private snackBar: SnackbarService,
    private _location: Location, private errorEvent: EventService,
    private _candidateService: CandidateService,
    private examSchService: ExamScheduleService,
    private complaintService: ComplaintService,
    private activatedRoute: ActivatedRoute,
    private questionBankService: QuestionBankService) {
  }

  openQuickpanel(): void {
    this.layoutService.openQuickpanel();
  }

  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  ngOnInit() {
    this.enableDetails = true;
    this.enableOperations = true;
    this.enableReports = true;
    //when route changes needs to be updated
    this.route.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.setTitle();
      }
      this.setDetails();
    });
    this.setTitle();
    this.setDetails();
    this.errorEventHandler = this.errorEvent.httpErrorMessageEvent.subscribe((message: string) => {
      if (message) {
        let i = this.errorEvent.getErrID();
        if (message.includes(i)) {
          message = message.replace(i, '');
          this.snackBar.error(message)

          this.errorEvent.setErrID(null)
        }

      }
    });
  }
  setDetails() {
    this.canBack = true;

    this.currentRoute = this.route.routerState.snapshot.url.split('?')[0];
    // console.log(this.currentRoute);
    this.enableDetails = true;
    this.enableOperations = true;
    this.enableReports = true;
    this.enableSetUp = false;
    if (this.currentRoute == '/exams' || this.currentRoute == '/candidates' || this.currentRoute.includes('/complaints')) {
      this.enableOps = true;
    }
    else if (/^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute) || this.currentRoute.includes('candidates/view')) {
      this.enableOps = true;
    }
    else {
      this.enableOps = false;
    }

    if (this.currentRoute == '/candidates' || this.currentRoute.includes('/complaints')) {
      this.enableReports = false;
      if (this.currentRoute.includes('/complaints')) {
        this.enableOperations = false;
      }
      if (this.currentRoute.includes('/complaints/view')) {
        this.enableDetails = true;
        this.enableOperations = true;
      }
    }
    if (this.currentRoute == '/candidates' || this.currentRoute == '/dashboard' || this.currentRoute == '/exams') {
      this.canBack = false;
    }
    if (this.currentRoute == '/exams' || this.currentRoute =='/questions-bank') {
      this.enableSetUp = true;
    }

    if (this.currentRoute === "/exam-groups") {
      this.enableDetails = true;
      this.enableOps = true;
      this.enableOperations = false;
      this.enableReports = false;
      this.enableSetUp = false;
    }

    if (this.currentRoute.includes(`/exams/${this.examService.selectedExamIds[0]}/schedules/${this.examSchService.selectedIds}`)) {
      this.enableOps = true;
      this.enableOperations = true;
      this.enableDetails = true;
      this.enableReports = true;
    }

    if (this.currentRoute === "/questions-bank") {
      this.enableDetails = true;
      this.enableOps = true;
      this.enableOperations = true;
      this.enableReports = false;
    }

    if (this.currentRoute == '/exams'
      || /^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute)
      || this.currentRoute == '/candidates' || this.currentRoute.includes('/complaints')) {
      this.enableOps = true;
    }

    if (this.currentRoute == '/candidates' || this.currentRoute.includes('/complaints')) {
      this.enableReports = false;
      if (this.currentRoute.includes('/complaints')) {
        this.enableOperations = false;
      }
    }

    if (this.currentRoute == '/candidates' || this.currentRoute == '/dashboard' || this.currentRoute == '/exams') {
      this.canBack = false;
    }
    if (this.currentRoute == '/exams' || this.currentRoute == '/questions-bank') {
      this.enableSetUp = true;
    }
    if (this.currentRoute.includes(`/exams/${this.examService.selectedExamIds}/schedules/${this.examSchService.selectedIds}`)) {
      this.enableOps = true;
      this.enableDetails = true;
      this.enableReports = true;
    }

    if (/^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute)) {
      this.enableOps = true;
      this.enableDetails = true;
      this.enableReports = true;
    }
    if (this.currentRoute.includes('candidates/view')) {
      this.enableOps = true;
      this.enableDetails = true;
      this.enableReports = false;
    }

    if (/^\/?exams\/\d+\/questions(\/.*)?$/.test(this.currentRoute)) {
      this.enableOps = true;
      this.enableOperations = true;
      this.enableDetails = false;
      this.enableReports = false;
    }
    // console.log(`EnabeOps: ${this.enableOps}, EnableDetails: ${this.enableDetails}, EnableReports: ${this.enableReports}, EnableSetUp: ${this.enableSetUp}, EnableOperations: ${this.enableOperations}  for route ${this.currentRoute}`);

  }

  GoBack() {
    this._location.back();
  }

  ngOnDestroy() {
    if (this.errorEventHandler) {
      this.errorEventHandler.unsubscribe()
    }
  }
  openDetailsMenu(origin: ElementRef | HTMLElement): void {

    if (!this.handleExam(MenuType.details)) {
      return;
    }

    if (!this.handleExamSchedule(MenuType.details)) {
      return;
    }

    if (!this.handleExamCandidates(MenuType.details)) {
      return
    }
    if (!this.handleComplaints(MenuType.details)) {
      return
    }
    if (!this.handleExamGroup(MenuType.details)) {
      return
    }
    if (!this.handleQuestionsBank(MenuType.details)) {
      return
    }


    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: DetailsMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openReportsMenu(origin: ElementRef | HTMLElement): void {

    // if (this.currentRoute == '/exams' && this.exam == null) {
    //   if (this.examService.selectedExams?.length === 1) {
    //     this.exam = this.examService.selectedExams[0];
    //   }

    //   if (this.examService.selectedExams?.length > 1) {
    //     this.snackBar.open('Multiple Examinations Selected', 'CLOSE', {
    //       duration: 3000,
    //       horizontalPosition: 'right', verticalPosition: 'top',
    //       panelClass: ['warning-dialog']
    //     });
    //     return;
    //   }

    //   if (this.exam == null) {
    //     this.snackBar.open('No Examination Selected', 'CLOSE', {
    //       duration: 3000,
    //       horizontalPosition: 'right', verticalPosition: 'top',
    //       panelClass: ['warning-dialog']
    //     });
    //   }
    //   return;
    // }

    if (!this.handleExam(MenuType.reports)) {
      return;
    }

    if (!this.handleExamSchedule(MenuType.reports)) {
      return;
    }

    if (!this.handleExamCandidates(MenuType.reports)) {
      return
    }

    // if (this.currentRoute == '/candidates') {
    //   if (this.candidate == null) {
    //     

    //     if (this._candidateService.selectedCandidates?.length === 1) {
    //       this.candidate = this._candidateService.selectedCandidates?[0];
    //     }

    //     if (this._candidateService.selectedCandidates?.length > 1) {
    //       this.snackBar.open('Multiple Candidates Selected', 'CLOSE', {
    //         duration: 3000,
    //         horizontalPosition: 'right', verticalPosition: 'top',
    //         panelClass: ['warning-dialog']
    //       });
    //       return;
    //     }

    //     this.snackBar.open('No Candidate Selected', 'CLOSE', {
    //       duration: 3000,
    //       horizontalPosition: 'right', verticalPosition: 'top',
    //       panelClass: ['warning-dialog']

    //     });
    //     return;
    //   }
    // }


    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: ReportsMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openSetUpMenu(origin: ElementRef | HTMLElement): void {

    if (!this.handleExam(MenuType.setup)) {
      return;
    }

    if (!this.handleExamSchedule(MenuType.setup)) {
      return;
    }

    if (!this.handleExamCandidates(MenuType.setup)) {
      return
    }

    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: SetupMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }


  openOperationsMenu(origin: ElementRef | HTMLElement): void {
    if (this.examService.selectedExams !== null && this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
    }

    if (this.examService.selectedExams !== null && this.examService.selectedExams?.length > 1) {
      this.exam = examDefault;
    }

    if (!this.handleExam(MenuType.operations)) {
      return;
    }

    if (!this.handleExamSchedule(MenuType.operations)) {
      return;
    }

    if (!this.handleExamCandidates(MenuType.operations)) {
      return
    }

    if (!this.handleQuestionsBank(MenuType.operations)) {
      return
    }

    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: OperationMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openSearch(): void {
    this.layoutService.openSearch();
  }

  handleExamSchedule(type: MenuType) {
    if (/^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute)) {

      if (this.examSchService.selectedIds.length === 0 || (this.examSchService.selectedSchedules?.length === 0)) {
        this.snackBar.warning('No Examination Schedule Selected');
        return false;
      }
      else if (this.examSchService.selectedIds.length > 1 && (type === MenuType.details || type === MenuType.reports || type === MenuType.setup)) {
        this.snackBar.warning('Multiple Examination Schedules Selected');
        return false;

      } else if (type === MenuType.setup) {
        return false;
      }
    }
    return true;
  }

  handleExamCandidates(type: MenuType) {
    if (this.currentRoute == '/candidates') {
      if (this._candidateService.selectedCandidates?.length === 0) {
        this.snackBar.warning('No Candidate Selected');
        return false;
      }
      else if (this._candidateService.selectedCandidates?.length > 1 && (type === MenuType.details || type === MenuType.reports || type === MenuType.setup)) {
        this.snackBar.warning('Multiple Candidates Selected');
        return false;
      } else if (type === MenuType.setup) {
        return false;
      }
    }
    return true;
  }
  handleComplaints(type: MenuType) {
    if (this.currentRoute.includes('/complaints')) {
      if (this.complaintService.selectedComplaints.length === 0) {
        this.snackBar.warning('No Ticket Selected');
        return false;
      }
      else if (this.complaintService.selectedComplaints.length > 1 && (type === MenuType.details || type === MenuType.reports || type === MenuType.setup)) {
        this.snackBar.warning('Multiple Tickets Selected');
        return false;
      } else if (type === MenuType.setup) {
        return false;
      }
    }
    return true;
  }

  handleExam(type: MenuType) {
    if (this.currentRoute == '/exams') {

      if (this.examService.selectedExams?.length === 0) {
        if ((this.exam == null || this.examService.selectedExams?.length <= 0) && type !== MenuType.reports) {
          this.snackBar.warning('No Examination Selected'); 
          return false;
        }
      }
      else if (this.examService.selectedExams?.length > 1 && (type === MenuType.details || type === MenuType.reports || type === MenuType.setup)) {
        this.snackBar.warning('Multiple Examinations Selected');
        return false;
      }
    }
    return true;
  }

  handleExamGroup(type: MenuType) {
    if (this.currentRoute == '/exam-groups') {

      if (this.examService.selectedExamGroups.length === 0) {
        if (this.examService.selectedExamGroups.length <= 0) {
          this.snackBar.warning('No Examination Group Selected');
          return false;
        }
      }
      else if (this.examService.selectedExamGroups.length > 1 && (type === MenuType.details || type === MenuType.reports || type === MenuType.setup)) {
        this.snackBar.warning('Multiple Examinations Group Selected');
        return false;
      }
    }
    return true;
  }

  handleQuestionsBank(type: MenuType) {
    if (this.currentRoute == '/questions-bank') {

      if (this.questionBankService.selectedQuestionBanks.length === 0) {
        if (this.questionBankService.selectedQuestionBanks.length <= 0) {
          this.snackBar.warning('No Questions Bank Selected');
          return false;
        }
      }
      else if (this.questionBankService.selectedQuestionBanks.length > 1 && (type === MenuType.details || type === MenuType.reports || type === MenuType.setup)) {
        this.snackBar.warning('Multiple Questions banks Selected');
        return false;
      }
    }
    return true;
  }

  openProfileMenu(origin: HTMLDivElement): void {
    this.userMenuOpen$ = of(
      this.popoverService.open({
        content: UserMenuComponent,
        origin,
        offsetY: 5,
        offsetX: origin.clientWidth - 200,
        width: origin.clientWidth,
        position: [
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  setTitle() {
    let lastChild = this.activatedRoute;
    while (lastChild.firstChild) {
      lastChild = lastChild.firstChild;
    }
    this.title = lastChild.snapshot.data['title'] || lastChild.snapshot.routeConfig?.title || '';
  }
}

enum MenuType {
  details,
  operations,
  reports,
  setup
}
